module.exports = __webpack_public_path__ + "static/media/desktop-hb-prime-landing.a12edd17.png";